
import React from 'react';
import JobsHero from '@/components/jobs/JobsHero';
import JobVacancies from '@/components/jobs/JobVacancies';
import EmployeeTestimonials from '@/components/jobs/EmployeeTestimonials';
import JobApplicationCTA from '@/components/jobs/JobApplicationCTA';
import JobsSEO from '@/components/jobs/JobsSEO';

const Jobs = () => {
  return (
    <>
      <JobsSEO />
      <main id="main-content" className="pt-20">
        <JobsHero />
        <JobVacancies />
        <EmployeeTestimonials />
        <JobApplicationCTA />
      </main>
    </>
  );
};

export default Jobs;
